<template>
    <section class="dp-layout league-affair-summary-page">
        <section class="dp-left">
            <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
        </section>

        <section class="dp-right">
            <template v-if="schoolId > 0">
                <div class="filter-bar">
                    <el-form :inline="true" size="small">
                        <el-form-item label="年月">
                            <el-date-picker
                                v-model="filterForm.yearMonth"
                                type="month"
                                placeholder="选择月份"
                                value-format="yyyy-MM"
                                style="width: 140px;"
                                @change="handleSearch"
                            />
                        </el-form-item>
                        <el-form-item label="校区">
                            <el-select v-model="filterForm.campusId" placeholder="请选择校区" clearable style="width: 140px;" @change="handleSearch">
                                <el-option v-for="item in campusOptions" :key="item.Id" :label="item.Name" :value="item.Id" />
                            </el-select>
                        </el-form-item>
                        <el-form-item label="状态">
                            <el-select v-model="filterForm.completionFilter" placeholder="全部参与班" clearable style="width: 150px;" @change="handleSearch">
                                <el-option label="已加分" value="scored" />
                                <el-option label="有签到未加分" value="pending" />
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
                        </el-form-item>
                    </el-form>
                </div>

                <el-alert
                    v-if="summary.FeatureTip"
                    :title="summary.FeatureTip"
                    type="warning"
                    :closable="false"
                    show-icon
                    class="tip-alert"
                />

                <div class="stat-cards" v-loading="loading">
                    <div class="stat-card stat-card--success">
                        <div class="stat-card__num">{{ summary.ScoredClassCount || 0 }}</div>
                        <div class="stat-card__label">已加分班级</div>
                    </div>
                    <div class="stat-card stat-card--warning">
                        <div class="stat-card__num">{{ summary.PendingScoreClassCount || 0 }}</div>
                        <div class="stat-card__label">有签到未加分</div>
                    </div>
                    <div class="stat-card">
                        <div class="stat-card__num">{{ summary.CheckInStudentCount || 0 }}</div>
                        <div class="stat-card__label">签到人数</div>
                    </div>
                    <div class="stat-card">
                        <div class="stat-card__num">{{ summary.CheckInRecordCount || 0 }}</div>
                        <div class="stat-card__label">签到人次</div>
                    </div>
                </div>

                <div class="tbl-scroll-host">
                    <el-table
                        :data="summary.Items || []"
                        v-loading="loading"
                        border
                        height="100%"
                        class="compact-table summary-table"
                        highlight-current-row
                        @row-click="openDetail"
                    >
                        <el-table-column type="index" label="#" width="56" align="center" :index="indexMethod" />
                        <el-table-column prop="CampusName" label="校区" min-width="120" show-overflow-tooltip />
                        <el-table-column prop="ClassName" label="班级" min-width="140" show-overflow-tooltip />
                        <el-table-column label="状态" width="120" align="center">
                            <template slot-scope="scope">
                                <el-tag :type="statusTagType(scope.row.CompletionStatus)" size="mini">
                                    {{ scope.row.CompletionStatusText || statusText(scope.row.CompletionStatus) }}
                                </el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="TriggerStudentName" label="首签/触发学生" min-width="120" show-overflow-tooltip>
                            <template slot-scope="scope">{{ scope.row.TriggerStudentName || '-' }}</template>
                        </el-table-column>
                        <el-table-column label="签到人数" width="90" align="center">
                            <template slot-scope="scope">{{ scope.row.CheckInStudentCount != null ? scope.row.CheckInStudentCount : 0 }}</template>
                        </el-table-column>
                        <el-table-column label="签到次数" width="90" align="center">
                            <template slot-scope="scope">{{ scope.row.CheckInCount != null ? scope.row.CheckInCount : 0 }}</template>
                        </el-table-column>
                        <el-table-column label="时间" min-width="160" align="center">
                            <template slot-scope="scope">{{ formatDateTime(scope.row.SubmitTime) }}</template>
                        </el-table-column>
                        <el-table-column label="加分" width="90" align="center">
                            <template slot-scope="scope">
                                <span v-if="scope.row.Score != null">+{{ formatScore(scope.row.Score) }}</span>
                                <span v-else class="muted">-</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="加分状态" min-width="120" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <template v-if="scope.row.DutyScoreStatus != null">
                                    <el-tag :type="dutyScoreTagType(scope.row.DutyScoreStatus)" size="mini">
                                        {{ dutyScoreText(scope.row.DutyScoreStatus) }}
                                    </el-tag>
                                </template>
                                <span v-else class="muted">-</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="80" align="center" fixed="right">
                            <template slot-scope="scope">
                                <el-button type="text" size="small" class="table-op-link" @click.stop="openDetail(scope.row)">明细</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>

                <div class="pager">
                    <el-pagination
                        background
                        layout="total, sizes, prev, pager, next"
                        :total="total"
                        :current-page.sync="page"
                        :page-size.sync="pageSize"
                        :page-sizes="[10, 20, 50, 100]"
                        @current-change="loadSummary"
                        @size-change="handleSizeChange"
                    />
                </div>
            </template>

            <div v-else class="no-department-tip">
                <div class="no-department-tip__inner">
                    <i class="el-icon-school"></i>
                    <p>请在左侧选择所属学校，查看团务考核参与汇总</p>
                </div>
            </div>
        </section>

        <!-- 班级签到明细弹窗 -->
        <el-dialog
            :title="detailTitle"
            :visible.sync="detailVisible"
            width="900px"
            :close-on-click-modal="false"
            append-to-body
            custom-class="dialog-fixed-height league-summary-detail-dialog"
            @closed="onDetailClosed"
        >
            <div v-if="detailRow" class="detail-meta">
                <el-tag size="small" type="info" effect="plain">{{ detailRow.CampusName || '-' }}</el-tag>
                <el-tag size="small" effect="plain">{{ detailRow.ClassName || '-' }}</el-tag>
                <el-tag size="small" :type="statusTagType(detailRow.CompletionStatus)">
                    {{ detailRow.CompletionStatusText || statusText(detailRow.CompletionStatus) }}
                </el-tag>
                <span class="detail-meta__ym">{{ filterForm.yearMonth }}</span>
                <span class="detail-meta__stat">人数 {{ detailRow.CheckInStudentCount != null ? detailRow.CheckInStudentCount : 0 }}</span>
                <span class="detail-meta__stat">人次 {{ detailRow.CheckInCount != null ? detailRow.CheckInCount : 0 }}</span>
                <span v-if="detailRow.Score != null" class="detail-meta__stat">加分 +{{ formatScore(detailRow.Score) }}</span>
            </div>
            <div class="detail-table-wrap">
                <el-table
                    :data="detailList"
                    v-loading="detailLoading"
                    border
                    height="100%"
                    size="small"
                    class="compact-table"
                >
                    <el-table-column type="index" label="#" width="50" align="center" :index="detailIndexMethod" />
                    <el-table-column label="刷脸时间" width="160" align="center">
                        <template slot-scope="scope">{{ formatDateTime(scope.row.TouchTime) }}</template>
                    </el-table-column>
                    <el-table-column prop="StudentName" label="学生" min-width="100" show-overflow-tooltip />
                    <el-table-column prop="MeetingTag" label="会议标注" min-width="100" show-overflow-tooltip>
                        <template slot-scope="scope">{{ scope.row.MeetingTag || '-' }}</template>
                    </el-table-column>
                    <el-table-column prop="TerminalName" label="设备" min-width="120" show-overflow-tooltip>
                        <template slot-scope="scope">{{ scope.row.TerminalName || scope.row.TerminalId || '-' }}</template>
                    </el-table-column>
                    <el-table-column label="触发加分" width="90" align="center">
                        <template slot-scope="scope">
                            <el-tag :type="scope.row.ClassScoreApplied ? 'success' : 'info'" size="mini">
                                {{ scope.row.ClassScoreApplied ? '是' : '否' }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="抓拍" width="80" align="center">
                        <template slot-scope="scope">
                            <oss-el-image
                                v-if="scope.row.KqImageFile"
                                :src="scope.row.KqImageFile"
                                :preview-src-list="[scope.row.KqImageFile]"
                                :school-id="schoolId"
                                fit="cover"
                                class="detail-thumb"
                            />
                            <span v-else class="muted">-</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="detail-pager">
                <el-pagination
                    background
                    layout="total, sizes, prev, pager, next"
                    :total="detailTotal"
                    :current-page.sync="detailPage"
                    :page-size.sync="detailPageSize"
                    :page-sizes="[10, 20, 50]"
                    @current-change="loadDetailList"
                    @size-change="handleDetailSizeChange"
                />
            </div>
            <span slot="footer">
                <el-button type="primary" @click="detailVisible = false">关 闭</el-button>
            </span>
        </el-dialog>
    </section>
</template>

<script>
import DepartmentPane from '../../components/DepartmentPane';
import { getCampusList } from '../../api/modules/misc';
import {
    getLeagueAffairCompletionSummary,
    getLeagueAffairCheckInRecords
} from '../../api/modules/leagueAffair';
import { normalizeDeptId, deptIdsEqual, resolveActiveSchoolId } from '../../utils/deptCascaderProps';

export default {
    name: 'LeagueAffairSummary',
    components: { DepartmentPane },
    data() {
        const now = new Date();
        const ym = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
        return {
            schoolId: 0,
            schoolName: '',
            boundSchoolId: 0,
            loading: false,
            campusOptions: [],
            page: 1,
            pageSize: 10,
            total: 0,
            filterForm: {
                yearMonth: ym,
                campusId: null,
                completionFilter: ''
            },
            summary: {
                YearMonth: ym,
                FeatureEnabled: true,
                FeatureTip: '',
                ScoredClassCount: 0,
                PendingScoreClassCount: 0,
                CheckInStudentCount: 0,
                CheckInRecordCount: 0,
                Items: []
            },
            detailVisible: false,
            detailLoading: false,
            detailRow: null,
            detailList: [],
            detailPage: 1,
            detailPageSize: 10,
            detailTotal: 0
        };
    },
    computed: {
        detailTitle() {
            const name = (this.detailRow && (this.detailRow.ClassName || this.detailRow.className)) || '';
            return name ? `签到明细 · ${name}` : '签到明细';
        }
    },
    created() {
        const sid = this.resolveSchoolId();
        if (sid) this.applySchoolChange(sid, this.$store.state.activeSchoolName);
    },
    watch: {
        '$store.state.activeSchoolId'(newSchoolId) {
            this.applySchoolChange(newSchoolId, this.$store.state.activeSchoolName);
        }
    },
    methods: {
        /** 解析当前学校 Id（字符串，避免雪花 Id 被 Number 截断）。最后修改：2026-10-18 */
        resolveSchoolId() {
            const fromStore = resolveActiveSchoolId(this);
            if (fromStore) return fromStore;
            const local = normalizeDeptId(this.schoolId);
            if (local) return local;
            return '';
        },

        async applySchoolChange(schoolId, schoolName) {
            const id = normalizeDeptId(schoolId);
            if (!id) return;
            if (deptIdsEqual(id, this.schoolId) && deptIdsEqual(this.boundSchoolId, id)) return;
            this.schoolId = id;
            this.boundSchoolId = id;
            if (schoolName) this.schoolName = schoolName;
            this.page = 1;
            await this.loadCampusOptions(true);
            this.loadSummary();
        },

        treeNodeClick(data) {
            this.applySchoolChange(data && data.value, data && data.label);
        },

        indexMethod(index) {
            return (this.page - 1) * this.pageSize + index + 1;
        },

        detailIndexMethod(index) {
            return (this.detailPage - 1) * this.detailPageSize + index + 1;
        },

        handleSizeChange() {
            this.page = 1;
            this.loadSummary();
        },

        handleSearch() {
            this.page = 1;
            this.loadSummary();
        },

        pickDefaultCampusId() {
            const first = (this.campusOptions || [])[0];
            if (!first) return null;
            const id = first.Id != null ? first.Id : first.id;
            return id != null ? id : null;
        },

        formatScore(v) {
            const n = Number(v);
            if (Number.isNaN(n)) return '-';
            return Number.isInteger(n) ? String(n) : n.toFixed(2).replace(/\.?0+$/, '');
        },

        formatDateTime(v) {
            if (!v) return '-';
            const d = new Date(v);
            if (Number.isNaN(d.getTime())) return String(v).replace('T', ' ').slice(0, 19);
            const pad = n => (n < 10 ? '0' + n : '' + n);
            return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
        },

        statusTagType(status) {
            if (status === 'pending' || status === 'missing') return 'warning';
            if (status === 'scored' || status === 'submitted') return 'success';
            return 'info';
        },

        statusText(status) {
            if (status === 'pending' || status === 'missing') return '有签到未加分';
            if (status === 'scored' || status === 'submitted') return '已加分';
            return '-';
        },

        dutyScoreText(status) {
            if (status === 0) return '已加分';
            if (status === 1) return '待补分';
            if (status === 2) return '已回滚';
            return '-';
        },

        dutyScoreTagType(status) {
            if (status === 0) return 'success';
            if (status === 1) return 'warning';
            return 'info';
        },

        /**
         * 打开班级签到明细弹窗。创建于 2026-09-24
         */
        openDetail(row) {
            if (!row || !row.ClassId) {
                this.$message.warning('班级信息无效');
                return;
            }
            this.detailRow = row;
            this.detailPage = 1;
            this.detailVisible = true;
            this.loadDetailList();
        },

        onDetailClosed() {
            this.detailRow = null;
            this.detailList = [];
            this.detailTotal = 0;
            this.detailPage = 1;
        },

        handleDetailSizeChange() {
            this.detailPage = 1;
            this.loadDetailList();
        },

        /** 加载弹窗内该班本月签到流水 */
        async loadDetailList() {
            if (!this.schoolId || !this.detailRow || !this.detailRow.ClassId) return;
            this.detailLoading = true;
            try {
                const res = await getLeagueAffairCheckInRecords({
                    schoolId: this.schoolId,
                    yearMonth: this.filterForm.yearMonth || undefined,
                    campusId: this.detailRow.CampusId || undefined,
                    classId: this.detailRow.ClassId,
                    page: this.detailPage,
                    intPageSize: this.detailPageSize
                });
                if (res.data && res.data.success) {
                    const resp = res.data.response || {};
                    this.detailList = resp.data || [];
                    this.detailTotal = resp.dataCount || 0;
                } else {
                    this.detailList = [];
                    this.detailTotal = 0;
                    this.$message.error((res.data && res.data.msg) || '加载明细失败');
                }
            } catch (e) {
                this.detailList = [];
                this.detailTotal = 0;
                this.$message.error('加载明细失败');
            } finally {
                this.detailLoading = false;
            }
        },

        /**
         * 加载校区并默认选中第一个。创建于 2026-09-24
         * @param {boolean} forceDefault 是否强制覆盖当前选中校区
         */
        async loadCampusOptions(forceDefault = false) {
            if (!this.schoolId) return;
            try {
                const res = await getCampusList({ page: 1, intPageSize: 999, departmentId: this.schoolId });
                if (res.data && res.data.success) {
                    this.campusOptions = (res.data.response && res.data.response.data) || [];
                } else {
                    this.campusOptions = [];
                }
            } catch (e) {
                this.campusOptions = [];
            }
            const exists = this.campusOptions.some(c => String(c.Id != null ? c.Id : c.id) === String(this.filterForm.campusId));
            if (forceDefault || this.filterForm.campusId == null || !exists) {
                this.filterForm.campusId = this.pickDefaultCampusId();
            }
        },

        /** 加载团务考核月度参与汇总 */
        async loadSummary() {
            if (!this.schoolId || !this.filterForm.yearMonth) return;
            this.loading = true;
            try {
                const res = await getLeagueAffairCompletionSummary({
                    schoolId: this.schoolId,
                    yearMonth: this.filterForm.yearMonth,
                    campusId: this.filterForm.campusId || undefined,
                    completionFilter: this.filterForm.completionFilter || undefined,
                    page: this.page,
                    intPageSize: this.pageSize
                });
                if (res.data && res.data.success) {
                    const resp = res.data.response || {};
                    const items = resp.Items || resp.items || [];
                    const scored = Number(resp.ScoredClassCount != null ? resp.ScoredClassCount : (resp.SubmittedCount || resp.submittedCount || 0));
                    const pending = Number(resp.PendingScoreClassCount != null ? resp.PendingScoreClassCount : (resp.MissingCount || resp.missingCount || 0));
                    const studentCnt = Number(resp.CheckInStudentCount != null ? resp.CheckInStudentCount : (resp.checkInStudentCount || 0));
                    const recordCnt = Number(resp.CheckInRecordCount != null ? resp.CheckInRecordCount : (resp.DisabledCount || resp.disabledCount || 0));
                    this.summary = {
                        YearMonth: resp.YearMonth != null ? resp.YearMonth : resp.yearMonth,
                        FeatureEnabled: resp.FeatureEnabled !== false && resp.featureEnabled !== false,
                        FeatureTip: resp.FeatureTip || resp.featureTip || '',
                        ScoredClassCount: scored,
                        PendingScoreClassCount: pending,
                        CheckInStudentCount: studentCnt,
                        CheckInRecordCount: recordCnt,
                        Items: items
                    };
                    const count = resp.dataCount != null ? resp.dataCount
                        : (resp.DataCount != null ? resp.DataCount : 0);
                    this.total = Number(count) || 0;
                } else {
                    this.summary.Items = [];
                    this.total = 0;
                    this.$message.error((res.data && res.data.msg) || '加载失败');
                }
            } catch (e) {
                this.summary.Items = [];
                this.total = 0;
                this.$message.error('加载失败');
            } finally {
                this.loading = false;
            }
        }
    }
};
</script>

<style scoped>
.league-affair-summary-page .filter-bar {
    margin-bottom: 12px;
    flex: 0 0 auto;
}
.league-affair-summary-page .tip-alert {
    margin-bottom: 12px;
}
.league-affair-summary-page .stat-cards {
    display: flex;
    gap: 12px;
    margin-bottom: 14px;
    flex: 0 0 auto;
}
.league-affair-summary-page .stat-card {
    flex: 1;
    background: #F5F7FA;
    border-radius: 6px;
    padding: 14px 16px;
}
.league-affair-summary-page .stat-card__num {
    font-size: 24px;
    font-weight: 700;
    color: #303133;
    line-height: 1.2;
}
.league-affair-summary-page .stat-card__label {
    margin-top: 4px;
    color: #909399;
    font-size: 13px;
}
.league-affair-summary-page .stat-card--warning {
    background: #FDF6EC;
}
.league-affair-summary-page .stat-card--warning .stat-card__num {
    color: #E6A23C;
}
.league-affair-summary-page .stat-card--success {
    background: #F0F9EB;
}
.league-affair-summary-page .stat-card--success .stat-card__num {
    color: #67C23A;
}
.league-affair-summary-page .muted {
    color: #C0C4CC;
}
.league-affair-summary-page .pager {
    margin-top: 12px;
    text-align: right;
    flex: 0 0 auto;
}
.league-affair-summary-page .summary-table {
    width: 100%;
}
.league-affair-summary-page .summary-table:not(.el-table--scrollable-y) ::v-deep .el-table__body-wrapper {
    overflow-y: hidden !important;
}
.league-affair-summary-page .summary-table ::v-deep .el-table__body tr {
    cursor: pointer;
}
.league-affair-summary-page .table-op-link {
    padding: 0;
    color: #409EFF;
}
.no-department-tip {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}
.no-department-tip__inner {
    text-align: center;
    color: #909399;
}
.no-department-tip__inner i {
    font-size: 40px;
    margin-bottom: 12px;
}
</style>

<style>
/* 汇总明细弹窗：固定高度 + body 纵向布局（表格吃满剩余空间） */
.league-summary-detail-dialog .el-dialog__body {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    overflow: hidden;
    padding: 14px 20px 8px;
}
.league-summary-detail-dialog .detail-meta {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    margin-bottom: 12px;
    flex: 0 0 auto;
}
.league-summary-detail-dialog .detail-meta__ym,
.league-summary-detail-dialog .detail-meta__stat {
    color: #606266;
    font-size: 13px;
}
.league-summary-detail-dialog .detail-table-wrap {
    flex: 1;
    min-height: 0;
    overflow: hidden;
}
.league-summary-detail-dialog .detail-pager {
    margin-top: 10px;
    text-align: right;
    flex: 0 0 auto;
}
.league-summary-detail-dialog .detail-thumb {
    width: 40px;
    height: 40px;
    border-radius: 4px;
    overflow: hidden;
}
.league-summary-detail-dialog .muted {
    color: #C0C4CC;
}
</style>
